export default "__VITE_ASSET__BopH8P4a__"